import React, {FC} from 'react';
import {
  DataFetcher,
  useGrpcRequest,
  useGrpcRequestCallback,
} from '@aboutyou/data-fetcher';
import {SearchService_GetResolvedTerm} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.grpc';
import {useTargetGroupIdentifier} from '../../shared-deprecated/useTargetGroupIdentifier';
import {
  createRedirectHint,
  useCurrentPageType,
  useQueryParamsCallback,
} from '@aboutyou/router';
import {GetResolvedTermResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.types';
import {Log} from '@aboutyou/mlm';

export const ConditionalSearchTermRedirect = () => {
  const currentPageType = useCurrentPageType();
  const getQueryData = useQueryParamsCallback();
  const queryParam = getQueryData();
  const term = queryParam.get('term') ?? '';

  if (
    term === '' ||
    (currentPageType !== 'search' && currentPageType !== 'searchResults')
  ) {
    return null;
  }

  return <SearchTermRedirect term={term} />;
};

const SearchTermRedirect: FC<{term: string}> = ({term}) => {
  return <DataFetcher request={useGetResolvedTerm(term)} Error={null} />;
};

const useGetResolvedTerm = (term: string) => {
  const targetGroup = useTargetGroupIdentifier();

  const validateData = (data: GetResolvedTermResponse) => {
    if (data.result?.$case === 'resolvedUrl') {
      const resolvedUrl = data.result?.resolvedUrl;
      throw createRedirectHint(resolvedUrl.url, resolvedUrl.statusCode);
    }
  };

  return useGrpcRequest(
    SearchService_GetResolvedTerm,
    {
      targetGroup,
      term,
    },
    {
      validateData,
    },
  );
};

export const useGetSearchRedirect = () => {
  const targetGroup = useTargetGroupIdentifier();
  const query = useGrpcRequestCallback(SearchService_GetResolvedTerm);

  return async (term: string) => {
    try {
      const response = await query({
        targetGroup,
        term,
      });

      const resolvedUrl =
        response.result?.$case === 'resolvedUrl'
          ? response.result.resolvedUrl.url
          : undefined;

      return {
        url: resolvedUrl,
        searchType: response.searchTracker.searchType,
      };
    } catch (error) {
      Log.error('@aboutyou/logic-components', 'GetResolvedTermErrors', {
        error: error as Error,
      });
      return undefined;
    }
  };
};
